var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInboundSms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 150",
    enableBackground: "new 0 0 150 150",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2-2",
    fill: "#F24689",
    cx: 75.3,
    cy: 75.4,
    r: 75.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    fill: "#FFFFFF",
    d: "M108.9,33.5H41.8c-4.6,0-8.4,3.8-8.3,8.4v75.5l16.8-16.8h58.7c4.6,0,8.4-3.8,8.4-8.4V41.8 C117.3,37.2,113.5,33.4,108.9,33.5z M100.5,83.8H50.2v-8.4h50.3V83.8z M100.5,71.2H50.2v-8.4h50.3V71.2z M100.5,58.6H50.2v-8.4h50.3 V58.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboundSms);
export default __webpack_public_path__ + "static/media/inbound-sms.b7a5ecc472558027f5e44c6d56212eb8.svg";
export { ForwardRef as ReactComponent };